module.exports = __webpack_public_path__ + "283461f5dd58a3012a3ff0e9c0194e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-27.jpg
// module id = 1168
// module chunks = 0